export const MemberTypeEnum = Object.freeze({
    PUNTER: 0,
    ESCORT: 1,
    MANAGER: 2,
    VENUE: 3,
});
